import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';

import { PersonalIdentifierDetails } from '../../sj-orm';
import { TDtoWrapper } from '../form-wrapper.types';

import {
  commonDetailsFields,
  commonGeneralFields,
  commonLegalizedCopiesFields,
  LegalizedCopiesPartType,
  PersonalIdentifierDetailsFormType,
  PersonalIdentifierGeneralFormType,
} from './commonFields';

export type NationalIdGeneralFormType = PersonalIdentifierGeneralFormType;

export const NationalIdGeneralSection: NationalIdGeneralFormType = {
  ...commonGeneralFields,
};

export type NationalIdDetailsDto = Omit<PersonalIdentifierDetails, 'createdAt' | 'updatedAt'> & {
  cardAccessNumber?: string;
};

type NationalIdDetailsHelp = {
  cardAccessNumber: QuestionType.TEXT;
};

export type NationalIdDetailsFormType = Omit<PersonalIdentifierDetailsFormType, 'placeOfBirth'> &
  TDtoWrapper<NationalIdDetailsDto, NationalIdDetailsHelp>;

export const NationalIdDetailsSection: NationalIdDetailsFormType = {
  cardAccessNumber: {
    type: QuestionType.TEXT,
    label: 'forms_personal_ids:nationalId.inputs.cardAccessNumber.label',
    value: '',
    capitalized: true,
    order: 2,
  },
  ...commonDetailsFields,
};

export const NationalIdLegalizedCopiesSection: LegalizedCopiesPartType = {
  ...commonLegalizedCopiesFields,
};

export const NationalIdFormSections = [
  NationalIdGeneralSection,
  NationalIdDetailsSection,
  NationalIdLegalizedCopiesSection,
];
